<template>
    <Base>
      <template v-slot:basecontent>
        <div class="rounded py-[16px] px-[24px] pb-[32px] w-[391px] bg-theme-grey">
        
         <div class="flex justify-center mb-4">
            <div class="flex-auto justify-center items-center mt-1"> 
              <router-link class="text-theme-green mt-4" :to="{
                name: 'Login'
              }"> Back</router-link>
            </div>
            <div class="flex-auto w-64"> 
              <div class="text-2xl font-semibold text-white mt-0 pl-[12px] text-left">Password Reset</div>
            </div>
          </div>


          <p class="text-[16px] text-white text-center">
            Enter your email to get further instructions
          </p>
          <form @submit.prevent="onSubmit()" ref="forgotPassForm_">
            <div :class="'input-wrapper ' + (forgotPassForm.email.error_type)">
              <label class="mt-3 block label-text mb-1"> Email </label>
              <input
                class="shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline"
                type="email"
                v-model="forgotPassForm.email.value"
                @keyup="validateFields(['email'])"
              />
               <p class="field-error label-text mt-1" v-if="forgotPassForm.email.error_message" v-text="forgotPassForm.email.error_message"></p>
            </div>
            <button
              class="mt-8 bg-theme-green hover:bg-theme-darkgreen rounded w-[100%] text-[14px] text-bold text-white p-[8px]"
            >
              CONFIRM
            </button>
          </form>
        </div>
      </template>
    </Base>
</template>

<script lang="ts">
import { ref, computed, defineComponent } from "vue";
import Base from "./Base.vue";
import { useSnackbar } from "vue3-snackbar";
import LoginApis from  '@/controllers/LoginApis';
import Helpers from '@/helpers';
import { mapGetters, mapActions, mapMutations } from "vuex";

export default defineComponent({
  name: 'ForgotPassword',
  components: {
    Base
  },
  setup() {
    const snackbar = useSnackbar();
    const forgotPassForm = ref({
        email: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'email'],
        },
      });
    return {
      forgotPassForm,
      snackbar
    };
  },

  methods: {
    
    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.forgotPassForm, fields);
      // capture the fields
      this.forgotPassForm = res.data;
      return res.error ? false : true;
    },


    async onSubmit() {
      let validate = await this.validateFields(['email']);
      if(!validate) {
        return ;
      }

      this.va_spinner(true);
      let res = await LoginApis.forgetPassword({
        email: this.forgotPassForm.email.value
      });
      this.va_spinner(false);
      this.snackbar.add({
          type: 'info',
          text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
      })
      // on Success 
      if(res.status == 201) {
        this.forgotPassForm.email = {
            value: '',
            error_type: '',
            error_message: '',
            validations: ['required', 'email'],
        };
      }
    },

  
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  }
});

</script>
